import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const SystemFilledIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="SystemFilledIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/system/filled">
            <g id="Vector">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.08594 5C2.08594 3.89543 2.98137 3 4.08594 3H20.0859C21.1905 3 22.0859 3.89543 22.0859 5V9C22.0859 10.1046 21.1905 11 20.0859 11H4.08594C2.98137 11 2.08594 10.1046 2.08594 9V5ZM7.7207 7.0249C7.7207 7.57719 7.27299 8.0249 6.7207 8.0249C6.16842 8.0249 5.7207 7.57719 5.7207 7.0249C5.7207 6.47262 6.16842 6.0249 6.7207 6.0249C7.27299 6.0249 7.7207 6.47262 7.7207 7.0249Z"
                    fill="currentColor"
                ></path>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.91406 15C1.91406 13.8954 2.80949 13 3.91406 13H19.9141C21.0186 13 21.9141 13.8954 21.9141 15V19C21.9141 20.1046 21.0186 21 19.9141 21H3.91406C2.80949 21 1.91406 20.1046 1.91406 19V15ZM7.54883 17.0249C7.54883 17.5772 7.10111 18.0249 6.54883 18.0249C5.99654 18.0249 5.54883 17.5772 5.54883 17.0249C5.54883 16.4726 5.99654 16.0249 6.54883 16.0249C7.10111 16.0249 7.54883 16.4726 7.54883 17.0249Z"
                    fill="currentColor"
                ></path>
            </g>
        </g>
    </SvgIcon>
)
